const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class TripleCtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 1023px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('triple-cta-carousel')) {
  customElements.define('triple-cta-carousel', TripleCtaCarousel)
}
